
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.577 15.325l-5.49-5.466a.999.999 0 00-1.41 0L22.452 30.995c-.01.01-.01.01-.01.02-.08.08-.15.18-.19.289-.01.03-.02.05-.02.08-.02.05-.04.1-.05.149l-1.14 6.6c-.06.32.05.648.28.877.19.189.44.288.71.288.06 0 .11 0 .17-.01l6.63-1.134c.05-.01.1-.03.15-.05.03-.01.05-.01.08-.02.11-.05.199-.11.289-.19.01-.01.02-.01.02-.01L50.587 16.76c.19-.19.29-.438.29-.707 0-.269-.11-.538-.3-.727zm-5.59 4.162L28.65 35.754l-4.07-4.052 16.338-16.268 4.07 4.053zM23.822 33.752l2.76 2.748-3.33.567.57-3.315zm22.576-15.68l-4.079-4.062 2.06-2.051 4.07 4.052-2.05 2.06z"}}),_c('path',{attrs:{"d":"M46.977 31.881a1 1 0 00-1 .996v12.922c0 1.295-1.06 2.35-2.36 2.35H14.483c-1.3 0-2.36-1.055-2.36-2.35V16.79c0-1.295 1.06-2.35 2.36-2.35H27.46a1 1 0 001-.996 1 1 0 00-1-.995H14.482c-2.4 0-4.359 1.951-4.359 4.34V45.8c0 2.39 1.96 4.341 4.36 4.341h29.135c2.4 0 4.36-1.951 4.36-4.34V32.876a.988.988 0 00-1-.996z"}})])
          )
        }
      }
    